export const OPEN_INDEX_REPORT_TRANSACTION = 'INDEX_REPORT.OPEN_INDEX_REPORT_TRANSACTION';

export const SET_REPORT_DATA_ACTION = 'INDEX_REPORT.SET_REPORT_DATA_ACTION';
export const SET_SELECTED_REPORT_ITEM_ACTION = 'INDEX_REPORT.SET_SELECTED_REPORT_ITEM_ACTION';
export const SET_REPORT_DETAIL_DATA_ACTION = 'INDEX_REPORT.SET_REPORT_DETAIL_DATA_ACTION';
export const CREATE_NEW_INDEX_REPORT_ACTION = 'INDEX_REPORT.CREATE_NEW_INDEX_REPORT_ACTION';
export const LOAD_MORE_DATA_ACTION = 'INDEX_REPORT.LOAD_MORE_DATA_ACTION';
export const UPDATE_LOAD_OPTIONS_ACTION = 'INDEX_REPORT.UPDATE_LOAD_OPTIONS_ACTION';
export const SET_SEARCH_STRING_ACTION = 'INDEX_REPORT.SET_SEARCH_STRING_ACTION';
export const SET_HAS_MORE_ITEMS_ACTION = 'INDEX_REPORT.SET_HAS_MORE_ITEMS_ACTION';
